<script>
import { notify } from '@/helpers/notify' 

import {
  required
} from "vuelidate/lib/validators";
import Loader from "@/components/widgets/loader.vue";

export default {
    name: 'PaylinkModal',
    props:[
        "modelOpen",
        "data"
    ],
    components: {
        Loader
    },
    data() {
        return {
            form: {
                amount:0
            },
            amount:0,
            loading:false,
            submitted: false,
        };
    }, 
    watch:{
        modelOpen(){
            this.form = this.data
            this.amount = this.data.amount
        }
    },
    validations: {
        form: {  
            amount: { required },
        },
    },
    methods: {
        close(){
            this.$parent.$bvModal.hide('paylink_modal')
        },
        copyText() {
            const text = document.getElementById('swal-text').innerText;
            navigator.clipboard.writeText(text).then(() => {
               this.$swal('Kopyalandı!', 'Metin başarıyla kopyalandı.', 'success');
            }).catch(() => {
                this.$swal('Hata!', 'Metin kopyalanamadı.', 'error');
            });
        },
        handleSubmit(){
            this.loading = true
            this.$http.post('/members/' + this.form.subs_id + '/odemeLinki', { amount: this.form.amount,type: 'odeme' })
            .then(response => {
                this.loading = false
                if(response.data.code == 100){
                    this.$swal({
                        title: "Başarılı",
                        html: `
                            <p id="swal-text"> ${response.data.content}</p>
                            <button id="copy-button" class="swal2-confirm swal2-styled" style="margin-top: 10px;">Kopyala</button> `,
                        icon: "warning",
                        showConfirmButton: false,
                        didOpen: () => {
                            const copyButton = document.getElementById('copy-button');
                            copyButton.addEventListener('click', this.copyText);
                        }
                    });
                    return
                }
                return notify.error(response.data.message)
            })
        }
    },
};
</script>

<template>
<b-modal id="paylink_modal"  title="Ödeme Linki Gönder"  no-close-on-backdrop hide-footer>
    <form @submit.prevent="handleSubmit">
        <Loader :loading="true" :load="loading">
        <!--<div class="row">
            <div class="col-md-12">
                 <div class="alert alert-warning">
                   Toplam Ödemesi Gereken Tutar
                    <br>
                    {{ amount }}
                </div>
            </div>
        </div> -->
        <div class="row d-flex flex-wrap mb-1">
            <label class="col-sm-5 col-form-label col-form-label" for="amount">Ödenecek Tutar</label>
            <div class="col">
              <input
                id="amount" 
                v-model="form.amount"
                type="text"
                class="form-control"
                :class="{
                    'is-invalid': submitted && $v.form.amount.$error,
                }"
                />
                <div
                    v-if="submitted && $v.form.amount.$error"
                    class="invalid-feedback">
                    <span>Bu alanı doldurmak zorunludur.</span>
                </div>
          </div>
        </div>
        <div class="d-flex justify-content-between mt-3">
            <b-button variant="light" @click="close()">Vazgeç</b-button>
            <b-button 
                type="submit" 
                variant="warning" 
                class="ms-1"
                >Gönder
            </b-button>
        </div>
        </Loader>
    </form>
</b-modal>
</template>